import React, { FC, useState, useCallback } from "react";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField,
    DialogContentText, Typography
} from "@material-ui/core";
import { IConsequenceCategory, IDocument, } from "../types/types";
import Documents from "./documents";

interface CreateCategoryDialogProps {
    conseqenceCategory: IConsequenceCategory;
    open: boolean;
    handleClose: () => void;
    handleCreate: (category: IConsequenceCategory) => void;

}



const CreateCategoryDialog: FC<CreateCategoryDialogProps> = ({ conseqenceCategory, open, handleClose, handleCreate }) => {
    const [newCategory, setNewCategory] = useState<IConsequenceCategory>(conseqenceCategory);


    const [documentRef, setDocumentRef] = useState<IDocument>(() => {
        if (conseqenceCategory.document) {
            return conseqenceCategory.document
        }
        return {}
    });

    const updateDocumentSelection = useCallback((documentRef: IDocument) => {
        setDocumentRef(documentRef)

    }, [setDocumentRef]);


    const renderField = <T,>(obj: T, key: keyof T, label: string, type: string) => {
        return <div>
            <div style={{
                width: "100%",
                margin: "auto",
            }}>
                <TextField
                    fullWidth
                    label={label}
                    value={obj[key]}
                    onChange={(event) => {
                        let v = (event.target.value as string);

                        let c = { ...obj };
                        if (type == "string") {
                            (c as any)[key] = v
                        }
                        if (type == "number") {
                            (c as any)[key] = parseFloat(v)
                        }
                        setNewCategory(c)

                    }
                    }
                    type={type}
                />
            </div>
        </div>
    }

    const submitCategory = () => {
        let ra = { ...newCategory }
        if (documentRef?.id) {
            ra["document_id"] = documentRef.uuid;
        }
        handleCreate(ra);
        handleClose();
    }

    return (
        <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Add Consequence Category</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <p>
                        {renderField<IConsequenceCategory>(newCategory, "name", "Category Information", "string")}
                        {renderField<IConsequenceCategory>(newCategory, "category", "Category", "string")}
                        {renderField<IConsequenceCategory>(newCategory, "loss_rating", "Loss Rating", "string")}
                        {renderField<IConsequenceCategory>(newCategory, "pll", "PLL", "number")}
                        {renderField<IConsequenceCategory>(newCategory, "driver_of_severity", "Driver of Severity", "string")}
                        <Documents updateDocumentID={updateDocumentSelection} />
                    </p>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={submitCategory} color="primary">
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CreateCategoryDialog;
